export const channelKeys = {
  topicChannels: (studyGroupId: number | string) =>
    ["topicChannels", studyGroupId] as const,
  unreadCounts: (studyGroupId: number | string) =>
    ["channelUnreadCounts", studyGroupId] as const,
  topicChannelsSearch: (studyGroupId: number | string, keyword: string) =>
    ["topicChannelsSearch", studyGroupId, keyword] as const,
};
